import React, { Component } from 'react';
import IncidentService from '../../services/IncidentService';
import { isSet } from '../../utils/commonUtils';

class IncidentVisitsTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visits: [],
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        this.fetchVisits();
    }

    componentDidUpdate(prevProps) {
        // Refetch if incident_id changes
        if (prevProps.formData?.incident_id !== this.props.formData?.incident_id) {
            this.fetchVisits();
        }
    }

    fetchVisits = async () => {
        const { formData } = this.props;
        const incidentId = isSet(formData?.incident_id, '');

        if (!incidentId) {
            this.setState({ visits: [], loading: false });
            return;
        }

        this.setState({ loading: true, error: null });

        try {
            const response = await IncidentService.getVisitsByIncident(incidentId);
            if (response?.data?.visits) {
                this.setState({ visits: response.data.visits, loading: false });
            } else {
                this.setState({ visits: [], loading: false });
            }
        } catch (error) {
            console.error('Error fetching visits:', error);
            this.setState({ visits: [], loading: false, error: 'Failed to load visits' });
        }
    };

    getTypeBadge = (isFollowup) => {
        // is_followup = 0 means Parent, is_followup = 1 means Follow-up
        if (!isFollowup || isFollowup === 0) {
            return (
                <span className="badge sh_badgeSuccess">
                    <span className="pr-1">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <ellipse cx="4" cy="4" rx="4" ry="4" fill="#0F8647"></ellipse>
                        </svg>
                    </span>
                    Parent
                </span>
            );
        }
        return (
            <span className="badge sh_badgeWarning">
                <span className="pr-1">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="4" cy="4" rx="4" ry="4" fill="#CA8B14"></ellipse>
                    </svg>
                </span>
                Follow-up
            </span>
        );
    };

    getStatusBadge = (status) => {
        let badgeClass = 'sh_badgePending';
        let color = '#1D2433CC';
        
        switch (status) {
            case 'Complete & Discharged':
                badgeClass = 'sh_badgeSuccess';
                color = '#0F8647';
                break;
            case 'In Progress':
                badgeClass = 'sh_badgeWarning';
                color = '#CA8B14';
                break;
            case 'Cancelled':
            case 'In Active':
                badgeClass = 'sh_badgeDanger';
                color = '#E02D3C';
                break;
            case 'Scheduled':
                badgeClass = 'sh_badgePending';
                color = '#1D2433CC';
                break;
            default:
                badgeClass = 'sh_badgePending';
                color = '#1D2433CC';
        }

        return (
            <span className={`badge ${badgeClass}`}>
                <span className="pr-1">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="4" cy="4" rx="4" ry="4" fill={color}></ellipse>
                    </svg>
                </span>
                {status || '-'}
            </span>
        );
    };

    render() {
        const { visits, loading, error } = this.state;
        const { formData } = this.props;
        const incidentId = isSet(formData?.incident_id, '');

        if (!incidentId) {
            return (
                <div className="text-center p-4">
                    <p className="text-muted">Save the incident first to view mapped visits.</p>
                </div>
            );
        }

        if (loading) {
            return (
                <div className="text-center p-4">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="text-center p-4">
                    <p className="text-danger">{error}</p>
                </div>
            );
        }

        if (visits.length === 0) {
            return (
                <div className="text-center p-4">
                    <p className="text-muted">No visits mapped to this incident.</p>
                </div>
            );
        }

        return (
            <div className="sh_cardBox">
                <div className="sh_cardHeader">
                    <h6 className="text-md mb-0 font-weight-bold">Mapped Visits</h6>
                </div>
                <div className="sh_cardBody p-0">
                    <div className="table-responsive">
                        <table className="table sh_table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Visit Date</th>
                                    <th>Visit Category</th>
                                    <th>Visit Status</th>
                                    <th>Patient Name</th>
                                    <th>Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {visits.map((visit, index) => (
                                    <tr key={visit.visit_id}>
                                        <td>{index + 1}</td>
                                        <td>{visit.visit_date || '-'}</td>
                                        <td>{visit.visit_category || '-'}</td>
                                        <td>{this.getStatusBadge(visit.visit_status)}</td>
                                        <td>{visit.employee_name || '-'}</td>
                                        <td>{this.getTypeBadge(visit.is_followup)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default IncidentVisitsTab;
